/* ==========================================================================
   Icon list — desktop mouse drag-to-scroll.

   Touch swipe and trackpad scrolling work natively; this only adds click-and-
   drag for mouse users (the scrollbar is hidden). Touch pointers are left to the
   browser. A small movement threshold suppresses the click after a drag so
   dragging a linked pill doesn't navigate.
   ========================================================================== */

(function () {
  if (window.__iconListInit) return;
  window.__iconListInit = true;

  var THRESHOLD = 6; // px of movement before it counts as a drag

  function initTrack(track) {
    if (!track || track.__ilReady) return;
    track.__ilReady = true;

    var down = false;
    var startX = 0;
    var startScroll = 0;
    var moved = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;            // touch scrolls natively
      if (track.scrollWidth <= track.clientWidth) return; // nothing to scroll
      down = true;
      moved = 0;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      track.scrollLeft = startScroll - dx;
      if (Math.abs(dx) > 2) e.preventDefault();
    });

    var end = function (e) {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
      // If it was a real drag, swallow the click that follows.
      if (moved > THRESHOLD) {
        track.__ilSuppressClick = true;
        setTimeout(function () { track.__ilSuppressClick = false; }, 0);
      }
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);

    track.addEventListener('click', function (e) {
      if (track.__ilSuppressClick) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  function initAll() {
    document.querySelectorAll('.icon-list__track').forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var track = e.target.querySelector('.icon-list__track');
      if (track) initTrack(track);
    });
  }
})();
